import { render } from "./GridCampanii.vue?vue&type=template&id=1c9d53e9&scoped=true&ts=true"
import script from "./GridCampanii.vue?vue&type=script&lang=ts"
export * from "./GridCampanii.vue?vue&type=script&lang=ts"

import "./GridCampanii.vue?vue&type=style&index=0&id=1c9d53e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9d53e9"]])

export default __exports__